<br>
<div class="form-row btntop col-sm-12 d-flex align-items-center" style="margin-top: 10px;">
  <div class="d-flex justify-content-start w-100">
    <div class="d-flex align-items-center gap-2 w-100">
      
      <!-- Knapparna -->
      <div class="d-flex gap-1">
        <button class="btn border" (click)="saveToPDF()">Skapa Pdf</button>
      </div>

      <!-- Labeln -->
      <p class="reportlabel mb-0 ms-3">Rapport: Institutioner per distrikt<i *ngIf="showSpinner" class="fa fa-spinner fa-spin" style="font-size:32px;color:#920000;margin-left:30px;"></i></p>

    </div>
  </div>
</div>

<div class="container" id="contentToConvert" style="width:600px;margin-left:10px !important;">
  <br>
<div class="col-md-12">
  <br>
  <p-menubar *ngIf="institutionsperdistrict?.length > 0" [model]="items">
    <div style="margin-top:5px;margin-right:10px;">
      
      <div class="d-flex justify-content-between">
        <p-select [options]="districtlist" [(ngModel)]="value" optionLabel="shortName" [filter]="true" filterBy="shortName" [showClear]="true" placeholder="Filtrera" (onChange)="filterDistrict($event)" class="w-full md:w-56">
          <ng-template #selectedItem let-selectedOption>
            <div class="flex items-center gap-2">
            
              <div>{{ value.shortName }} - {{value.name}}</div>
            </div>
          </ng-template>
          <ng-template let-district #item>
            <div class="flex items-center gap-2">         
              <div>{{ district.shortName }} - {{district.name}}</div>
            </div>
          </ng-template>
        </p-select>
</div>
        <!--p-dropdown #dd *ngIf="institutionsperdistrict?.length > 0" class="pull-right" [options]="districtlist" filter="true" [showClear]="true" optionLabel="districtName" [style]="{'width':'30px'}" (onChange)="filterDistrict($event)" (click)="clearFilter(dd);" appendTo="body"></p-dropdown-->
  </div>
  </p-menubar>
  <div *ngFor="let ipd of institutionsperdistrict">
    <table class="table table-bordered border">
      <tr style="font-weight:bold;background-color:#F0F0F0;">
        <td>{{ipd.shortName}}</td>
        <td>{{ipd.name}}</td>
        <td></td>
        <td>{{ipd.memberFullName}}</td>
      </tr>
      <tr *ngFor="let i of ipd.institutions; let idx = index;">
        <td>{{i.shortName}}</td>
        <td>{{i.name}}</td>
        <td>{{i.seat}}</td>
        <td>{{i.noOfMembers}}</td>
      </tr>
      <tr style="background-color: #F0F0F0;height:32px;">
        <td colspan="4">{{ipd.shortName}} har
          <b style="background-color: #F0F0F0;">{{ipd.noOfMembersInLoge}}</b> medlemmar i loger</td>
      </tr>
      <tr style="background-color: #F0F0F0;height:32px;">
        <td colspan="4">{{ipd.shortName}} har
          <b style="background-color: #F0F0F0;">{{ipd.noOfMembersInLager}}</b> medlemmar i läger</td>
      </tr>
      <tr style="background-color: #F0F0F0;height:32px;">
        <td colspan="4">{{ipd.shortName}} har
          <b style="background-color: #F0F0F0;">{{ipd.percentInLager}}%</b> medlemmar i läger</td>
      </tr>
    </table>
  </div>
</div>
</div>
